module.exports = __webpack_public_path__ + "img/china.c5f4b5f8.svg";